// extracted by mini-css-extract-plugin
export default {"main":"future_kofzvZPew841","overlay":"future_rDtl30J1PDUO","background":"future_rdkcQSPkQnsq","iconFloatRight":"future_iGjfON1ThCEr"};